<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('balanceSheet') }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-shortkey="['f5']"
            v-bind="attrs"
            icon
            small
            class="float-left"
            @shortkey="getItems"
            v-on="on"
            @click="getItems"
          >
            <v-icon
              color="blue"
              style="font-size: 22px"
            >
              mdi-refresh
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('refresh') }}(f5)</span>
      </v-tooltip>
<log
        ref="logRef"
        v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
        :type-prop="type"
        mode-prop="button"
      />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            class="float-left"
            small
            v-on="on"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
              @click="filter = true"
            >
              mdi-filter-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('filter') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            class="float-left"
            small
            v-on="on"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
              @click="printDialog = true"
            >
              mdi-cloud-print-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('print') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-row class="mx-0 mb-2">
      <v-col
        class=" px-2"
        cols="12"
        md="6"
      >
        <div
          v-for="(total, j) in property"
          :key="j"
        >
          <v-list>
            <v-banner
              single-line
            >
              <h3 style="color: teal">
                {{ total[0].groupName }}
              </h3>
            </v-banner>
            <v-list-item-group
              active-class="pink--text"
              class="px-3"
            >
              <template v-for="(item, index) in total">
                <v-list-item :key="index">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.totalName" />
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-list-item-action-text
                      style="font-size: 14px !important;"
                      v-text="$numberFormat(item.remain) + ' ' + $store.state.currency.symbol"
                    />
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </div>
        <v-divider />
        <div
          v-if="sum"
          class="d-flex float-end pa-2"
        >
          <h5>{{ $t('sum') }}     :     </h5>
          <h4>
            {{ $numberFormat(sum.sumproperty) }} {{ $store.state.currency.symbol }}
          </h4>
        </div>
        <v-col class="mt-6">
          <div
            v-if="sum"
            class="d-flex pa-2"
            style="color: deeppink"
          >
            <v-alert
              dense
              outlined
              type="error"
              class="pa-2 py-0"
            >
              {{ $t('difference') }}  :  <strong>{{ $numberFormat(sum.difference) }}</strong> {{ $store.state.currency.symbol }}
            </v-alert>
          </div>
        </v-col>
      </v-col>
      <v-col
        class=" px-2"
        cols="12"
        md="6"
      >
        <div
          v-for="(total, j) in debts"
          :key="j"
        >
          <v-list>
            <v-banner
              single-line
            >
              <h3 style="color: deeppink">
                {{ total[0].groupName }}
              </h3>
            </v-banner>
            <v-list-item-group
              active-class="pink--text"
              class="px-3"
            >
              <template v-for="(item, index) in total">
                <v-list-item :key="index">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.totalName" />
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-list-item-action-text
                      style="font-size: 14px !important;"
                      v-text="$numberFormat(-1*item.remain) + ' ' + $store.state.currency.symbol"
                    />
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
        </div>
        <v-list-item
          v-if="profit"
          class="px-6"
        >
          <v-list-item-content>
            <v-list-item-title
              style="color: dodgerblue"
              v-text="$t('costBenefit')"
            />
          </v-list-item-content>

          <v-list-item-action>
            <v-list-item-action-text
              style="font-size: 14px !important;"
              v-text="$numberFormat(-1*profit) + ' ' + $store.state.currency.symbol"
            />
          </v-list-item-action>
        </v-list-item>
        <v-divider />
        <div
          v-if="sum"
          class="d-flex float-end pa-2"
        >
          <h5>{{ $t('sum') }}     :     </h5>
          <h4>
            {{ $numberFormat(-1*sum.sumDebts) }} {{ $store.state.currency.symbol }}
          </h4>
        </div>
      </v-col>
    </v-row>
    <v-row />
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="filter = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('filter') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="fromId"
                v-model="fromDate"
                :label="$t('from') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="fromDate"
                element="fromId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <template>
              <v-text-field
                id="toId"
                v-model="toDate"
                :label="$t('until') + ' ' + $t('date')"
                outlined
                dense
                clearable
              />

              <date-picker
                v-model="toDate"
                element="toId"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                :min="fromDate"
                auto-submit
                :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                class=" mx-0"
                color="primary"
                @click="getItems"
              >
                {{ $t('filter') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left mx-0"
                @click="filter = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-card>
</template>

<script>
  import General from '../../../../Mixins/general'
  export default {
    name: 'BalanceSheet',
    components: {
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
    },
    mixins: [General],
    props: ['input', 'refId', 'accountProp', 'idProp'],
    data: () => ({
      selected: [],
      printDialog: false,
      deletDialog: false,
      showSelect: false,
      filter: false,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      fromDate: null,
      toDate: null,
      taskDialog: null,
      tag: null,
      profit: null,
      sum: null,
      deleteItem: null,
      sellStatus: null,
      property: [],
      debts: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      search: null,
      selectedHeaders: [],
      headersMap: null,
      fin4: null,
      given: null,
    }),
    computed: {
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
    },
    watch: {
      idProp () {
        this.getItems()
      },
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
    },
    beforeMount () {
      this.productStatusItems = [
        {
          value: 'active',
          text: this.$t('active'),
        },
        {
          value: 'deactive',
          text: this.$t('deactive'),
        },
      ]
    },
    mounted () {
      this.getItems()
    },
    methods: {
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'accountingEdit', params: { id: item.head_id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'accountingreport', {
          params: {
            start: app.fromDate,
            end: app.toDate,
            idProp: app.idProp,
            account: app.accountProp,
            search: app.search,
            page: app.options.page,
            refId: app.refId,
            type: app.type,
            report: 'balanceSheet',
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            app.debts = res.debts
            app.property = res.property
            app.profit = res.profit
            app.sum = res.sum
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped>

</style>
